"use client";

import { Table, TableBody, TableCell, TableRow } from "@workspace/frontend-ui";
import type { FC } from "react";
import useGameStats from "./hooks/useGameStats";

type Props = { game: SingleGameFragment };

const GameStatsTable: FC<Props> = ({ game }) => {
  const stats = useGameStats(game);

  return (
    <Table>
      <TableBody>
        {stats.map(({ label, value }) => (
          <TableRow
            key={label}
            className="border-none even:bg-background rounded-xl"
          >
            <TableCell className="text-muted-foreground">{label}</TableCell>
            <TableCell className="text-right font-medium text-foreground">
              {value}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default GameStatsTable;
